import React from "react";
import { Language } from "../../../data/constants";
import { ExamSessionCandidateExamState } from "../../../model/examSessionCandidate/ExamSessionCandidateExamViewModel";
import { OralExamOption } from "../../../model/OralExamOption";

export interface SchedulerCandidate {
  candidateId: string;
  firstName: string;
  lastName: string;
  language: Language;
}

export interface SchedulerExamCandidate {
  candidateId: string;
  examId: string;
  examState: ExamSessionCandidateExamState;
  moduleOption: OralExamOption;
  examDayId: string;
  roomId: string;
  timeSlotIndex: number;
  caseName?: string;
}

export interface SchedulerCandidateContext {
  isValid: boolean;
  schedulerCandidates: SchedulerCandidate[];
  schedulerExamCandidates: SchedulerExamCandidate[];
  addCandidate: (candidateId: string, examId: string, examDayId: string, roomId: string, timeSlotIndex: number) => void;
  removeCandidate: (candidateId: string, examId: string) => void;
  clearCandidates: (examDayId: string, roomId: string, timeSlotIndex: number) => void;
}

export const initialSchedulerCandidateContextValue: SchedulerCandidateContext = {
  isValid: true,
  schedulerCandidates: [],
  schedulerExamCandidates: [],
  addCandidate: (candidateId: string, examId: string, examDayId: string, roomId: string, timeSlotIndex: number) => {},
  removeCandidate: (candidateId: string, examId: string) => {},
  clearCandidates: (examDayId: string, roomId: string, timeSlotIndex: number) => {},
};

export const SchedulerCandidateContextValue = React.createContext<SchedulerCandidateContext>(
  initialSchedulerCandidateContextValue
);
